// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"261":"locale-fr-json","990":"locale-en-json"}[chunkId] + "." + {"261":"91823e8e","990":"563ace29"}[chunkId] + ".js";
};